import React, { useState } from "react";
import { Box, Container, Stack, Typography, TextField, Button, Alert } from "@mui/material";
import Navbar from "../../component/navbar/Navbar";
import Footer from "../../screens/Footer/Footer";

const DeleteAccount = () => {
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (!email) return;
    // Mailto-based submission so no backend dependency is needed.
    const subject = encodeURIComponent("Account Deletion Request");
    const body = encodeURIComponent(
      `Hello DoneRightAway team,\n\nPlease delete my account associated with: ${email}\n\nReason (optional): ${reason}\n\nThank you.`
    );
    window.location.href = `mailto:donerightaway44@gmail.com?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };

  return (
    <>
      <Navbar />
      <Box sx={{ bgcolor: "#FFFFFF", py: { xs: 6, md: 10 }, minHeight: "70vh" }}>
        <Container maxWidth="md">
          <Stack spacing={3}>
            <Typography sx={{ fontSize: { xs: 28, md: 38 }, fontWeight: 800, color: "#071D5B" }}>
              Delete Your Account
            </Typography>

            <Typography sx={{ fontSize: 16, color: "#374151", lineHeight: 1.7 }}>
              You can request permanent deletion of your DoneRightAway account at any time.
              Submit the form below and our team will remove your account and all associated
              personal data within <strong>30 days</strong>.
            </Typography>

            <Box sx={{ bgcolor: "#F9FAFB", p: 3, borderRadius: 2, border: "1px solid #E5E7EB" }}>
              <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#071D5B", mb: 1 }}>
                What gets deleted
              </Typography>
              <Box component="ul" sx={{ pl: 3, m: 0, color: "#374151", fontSize: 14, lineHeight: 1.9 }}>
                <li>Your profile (name, email, phone, profile photo)</li>
                <li>Saved addresses and favorite locations</li>
                <li>Stored payment methods (your Stripe customer record is also deleted)</li>
                <li>Messages with service providers</li>
                <li>Account preferences and notification settings</li>
              </Box>

              <Typography sx={{ fontSize: 15, fontWeight: 700, color: "#071D5B", mt: 3, mb: 1 }}>
                What we keep (for legal/tax obligations)
              </Typography>
              <Box component="ul" sx={{ pl: 3, m: 0, color: "#374151", fontSize: 14, lineHeight: 1.9 }}>
                <li>Order/invoice records for up to 7 years (required by Canadian tax law)</li>
                <li>Anonymized transaction logs (no personal identifiers)</li>
              </Box>
            </Box>

            {submitted ? (
              <Alert severity="success" sx={{ borderRadius: 2 }}>
                Your email client should have opened with a pre-filled deletion request.
                If it didn't, please email <strong>donerightaway44@gmail.com</strong> directly
                with your account email address.
              </Alert>
            ) : (
              <Box sx={{ bgcolor: "#FFFFFF", p: 3, borderRadius: 2, border: "1px solid #E5E7EB" }}>
                <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#071D5B", mb: 2 }}>
                  Request deletion
                </Typography>
                <Stack spacing={2}>
                  <TextField
                    label="Email associated with your account"
                    size="small"
                    fullWidth
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <TextField
                    label="Reason (optional)"
                    size="small"
                    fullWidth
                    multiline
                    minRows={3}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                  <Button
                    variant="contained"
                    disabled={!email}
                    onClick={handleSubmit}
                    sx={{
                      bgcolor: "#F15A24",
                      color: "#FFFFFF",
                      textTransform: "none",
                      fontWeight: 700,
                      px: 4,
                      py: 1.2,
                      borderRadius: "10px",
                      "&:hover": { bgcolor: "#d94f0f" },
                    }}
                  >
                    Send deletion request
                  </Button>
                </Stack>
              </Box>
            )}

            <Typography sx={{ fontSize: 13, color: "#6B7280" }}>
              Prefer to email us directly? Send your request to{" "}
              <a href="mailto:donerightaway44@gmail.com" style={{ color: "#0533B7" }}>
                donerightaway44@gmail.com
              </a>{" "}
              with the subject "Account Deletion Request" and the email address tied to your account.
              Requests are processed within 30 days.
            </Typography>
          </Stack>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default DeleteAccount;
